import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import queryString from "app/services/queryStringService";
import {
  getCancellationList,
  exportCancellationList,
} from "app/services/AdminServices/bookingService";
import _ from "lodash";
import { MdSearch } from "react-icons/md";
import { Helmet } from "react-helmet";
import { Button } from "react-bootstrap";
import config from "config.json";
import moment from "moment";
import usePagePermission from "app/hooks/usePagePermission";
import { AiFillFileExcel } from "react-icons/ai";
import HandyScroll from "app/common/Scroll";
import PassengerModal from "./Components/CancellationList/PassengerModal";

function CancellationList() {
  const { dateTimeFormat } = config;
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  const [showPassenger, setShowPassenger] = useState(false);
  const [passengers, setPassengers] = useState([]);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState();
  const [SearchBy, setSearchBy] = useState("Booking");
  const [toDate, setToDate] = useState();
  const [pnr, setPnr] = useState();

  const dateFormatter = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };

  function passengerFormatter(cell, row) {
    return (
      <Button onClick={(e) => getPassengerDetails(e, row)}> Passenger</Button>
    );
  }

  async function getPassengerDetails(e, value) {
    // const response = await bookingDetails(value.id);
    setPassengers(value.passengerList);
    setShowPassenger(true);
  }

  function handlePassengerClose() {
    setShowPassenger(false);
  }

  const priceFormatter = (cell, row) => (
    <span className="text-center">₹ {parseFloat(cell).toFixed(2)}</span>
  );

  const columns = [
    {
      dataField: "user.normalizedUserName",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "invoiceNo",
      text: "Invoice No",

      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "invoiceDate",
      text: "Booking Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDestination.cityCode",
      text: "To",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "departureDate",
      text: "Departure Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "arrivalDate",
      text: "Arrival Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },

    {
      dataField: "currentStatus",
      text: "Booking Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "netTotalFare",
      text: "Booked Price",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },

    {
      dataField: "refundAmount",
      text: "Refund Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "adminCancellationCharge",
      text: "Admin Cancellation Charge",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },
    {
      dataField: "adminMarkupAmount",
      text: "Admin Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: priceFormatter,
    },

    {
      dataField: "id",
      text: "passenger ",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: passengerFormatter,
    },
  ];

  function rowStyle(row, rowIndex) {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    if (row.currentStatus === "REJECTED") {
      style.backgroundColor = "#DCDCDC";
    }
    return style;
  }

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  }
  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fromDate":
        setFromDate(value);
        break;
      case "toDate":
        setToDate(value);
        break;
      case "pnr":
        setPnr(value);
        break;
      case "SearchBy":
        setSearchBy(value);
        break;

      default:
        break;
    }
  };
  async function loadBookingDetails() {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      fromDate,
      toDate,
      SearchBy,
      pnr,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getCancellationList(query);

    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
  }

  useEffect(() => {
    loadBookingDetails();
  }, [page, sizePerPage, fromDate, toDate, pnr, SearchBy]); // Call loadBookingDetails whenever page or sizePerPage changes

  function handleTableChange(type, { page, sizePerPage }) {
    setPage(page);
    setSizePerPage(sizePerPage);
  }

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);
    await loadBookingDetails();
  };
  const refreshFilter = (e) => {
    setFromDate("");
    setToDate("");
    setPnr("");
    setSearchBy("");
    // loadBookingDetails();
  };
  const exportAllReq = async () => {
    const query = queryString.getQueryStringFromObj({
      fromDate,
      SearchBy,
      toDate,
      pnr,
    });
    if (dataCount != 0) {
      setLoading(true);
    }

    const response = await exportCancellationList(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${moment().toISOString()}_Flight_Booked_List.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };
  const handleExport = async () => {
    setPage(page);
    setSizePerPage(sizePerPage);

    setTimeout(async () => {
      await exportAllReq();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Flight Cancellation List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Cancellation List" }]}></Breadcrumb>
      <div className="bookingList-header">
        <div className="row ">
          <div className="col-md-2 col-12">
            <div className="form-group">
              <label>Search By</label>
            </div>
            <select
              class="form-control"
              name="SearchBy"
              value={SearchBy}
              onChange={handleSearchChanges}
            >
              <option value={"Booking"}>Booking</option>
              <option value={"Travel"}>Travel</option>
            </select>
          </div>

          <div className="col-md-2 col-12">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="fromDate"
              value={fromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-2 col-12">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
          <div className="col-md-2 col-12">
            <div className="form-group">
              <label>PNR</label>
            </div>
            <input
              type="text"
              className="form-control"
              name="pnr"
              placeholder="PNR Search"
              value={pnr}
              onChange={handleSearchChanges}
            />
          </div>
          <div
            className="col d-flex justify-content-end mb-3"
            style={{ marginTop: "3%" }}
          >
            <button className="btn btn-outline-primary" onClick={handleSearch}>
              <MdSearch className="" size={18} />
            </button>
            <button className="btn btn-primary mx-2" onClick={refreshFilter}>
              Refresh
            </button>
            <Button
              variant="outline-primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
              {/* Export */}
              <AiFillFileExcel size={"25"} className="" />
            </Button>
          </div>
        </div>
      </div>
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Update PNR")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>

      <PassengerModal
        show={showPassenger}
        handleClose={handlePassengerClose}
        response={passengers}
      />
    </>
  );
}

export default CancellationList;
